import { render, staticRenderFns } from "./simplifyRoomFee.vue?vue&type=template&id=300c2b02&scoped=true"
import script from "./simplifyRoomFee.vue?vue&type=script&lang=js"
export * from "./simplifyRoomFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyRoomFee.vue?vue&type=style&index=0&id=300c2b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300c2b02",
  null
  
)

export default component.exports